import React from "react";
import GlobalStyle from "./components/GlobalStyle";
import { Route, Switch } from "react-router-dom";
import Routes from "./Routes";
import Header from "./components/Header";
import Footer from "./components/Footer";
import styled from "@emotion/styled";
import Top from "./components/Top";

const Box = styled.div`
  @media screen and (max-width: 1024px) {
    margin-top: 50px;
  }
`;


const App = () => {
  return (
    <Box className="app">
      <GlobalStyle />
      <Header />
      <div>
        <Switch>
          {Routes.map((route, i) => {
            const {path, exact, routes} = route;
            return (
              <Route 
                key={i}
                exact={exact}
                path={path}
                render={(routeProps) => <route.component routes={routes} {...routeProps} />}
              />
            )
          })}
        </Switch>
      </div>
      <Top />
      <Footer />
    </Box>
  )
}

export default App;
